// New version src/Common/locale/locale.service.ts CommonLocaleService
// Old version src/CaseDotStar.ServicePackages.Frontend.Locale/scripts/locale/locale_run.js LocaleRun

import {
	Injectable,
	Inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
	updateLocale,
	tz,
} from 'moment';
import 'moment-timezone';
import 'moment/locale/ru';
import { Observable } from 'rxjs';

import { CommonAppDataService } from '../app_data/app_data.service';
import { CommonUserDataService } from '../user_data.service';
import { CommonGeneralSettingsService } from '../general_settings.service';
import { CommonTranslateParamsPipe } from './translate_params.pipe';
import {
	LOCALE_TRANSLATIONS,
	TCommonLocaleDictionary,
} from './locale.translations.token';
import { ICommonKeyValues } from '../../@types/core';

export interface ICommonLocaleServiceData {
	localeKey: string;
	localeUrlPath: string;
	localeFileName: string;
	translations?: ICommonLocaleServiceTranslations;
}

export interface ICommonLocaleServiceTranslations extends ICommonKeyValues<TCommonLocaleServiceCompilerResult> {}
export type TCommonLocaleServiceCompilerResult = string | ((params: any) => string);

@Injectable({
	providedIn: 'root',
})
export class CommonLocaleService {
	readonly locale: string = this.commonAppDataService.getDataByPath('locale');

	constructor (
		private translateService: TranslateService,
		private commonAppDataService: CommonAppDataService,
		private commonUserDataService: CommonUserDataService,
		private commonGeneralSettingsService: CommonGeneralSettingsService,
		private commonTranslateParamsPipe: CommonTranslateParamsPipe,
		@Inject(LOCALE_TRANSLATIONS) protected translations: TCommonLocaleDictionary,
	) {
		this.translateService.setTranslation(this.locale, this.translations[this.locale]);
	}

	init (): Observable<any> {
		this.translateService.setDefaultLang(this.locale);

		return this.translateService.use(this.locale);
	}

	setFormats (): void {
		const userTimeZone = this.commonUserDataService.getDataByPath('TimeZone');
		const timeFormat = this.commonGeneralSettingsService.getGeneralSettings('TimeFormat');
		const dateFormat = this.commonGeneralSettingsService.getGeneralSettings('DateFormat');

		if (timeFormat) {
			updateLocale(this.locale, {
				longDateFormat: {
					LT: timeFormat.Format,
					L: dateFormat.ShortFormat,
					LL: '',
					LLL: '',
					LLLL: '',
					LTS: '',
				},
				meridiemParse: new RegExp(timeFormat.PmDesignator + '|' + timeFormat.AmDesignator, 'gi'),
				isPM: (input) => input === timeFormat.PmDesignator,
				meridiem: (hours) => hours > 11 ? timeFormat.PmDesignator : timeFormat.AmDesignator,
				week: {
					doy: 1,
					dow: (this.commonGeneralSettingsService.getGeneralSettings('DayOfWeek').IndexNumber || 0) + 1 ,
				},
			});
		}

		if (userTimeZone) {
			tz.setDefault(userTimeZone.IanaId);
		}
	}

	// todo: remove CommonTranslateParamsPipe and this method later, instead use TranslateService#instant
	// Now this method used only for backward compatibility with ng1
	instant (key: string, params?: {[key: string]: any }): string {
		let res = this.translateService.instant(key, params);

		if (params) {
			res = this.commonTranslateParamsPipe.transform(res, params);
		}

		return res;
	}
}
